import axios from 'axios'
import baseUrl from './baseUrl'

const axiosInstance = axios.create({ baseURL: baseUrl() })
axiosInstance.defaults.withCredentials = true

/* eslint-disable-next-line import/no-mutable-exports */
let csrfToken = null

axiosInstance.interceptors.request.use(config => {
  // eslint-disable-next-line no-param-reassign
  config.headers['X-CSRF-Token'] = csrfToken
  return config
})

axiosInstance.interceptors.response.use(response => {
  if (response.headers['csrf-token']) {
    csrfToken = response.headers['csrf-token']
  }

  return response
})

export { axiosInstance as restClient, csrfToken, axios }
